import type { SegmentedControlItem } from '@byecode/ui'
import type { ButtonShowType, ButtonSizeType } from '@lighthouse/core'
import { ActionHandleEventType, ActionItemPattern, ButtonSize } from '@lighthouse/core'

import type { ButtonConfig } from '../types/button'

export const btnStyleMap = new Map<ActionItemPattern, React.CSSProperties>([
    [
        ActionItemPattern.primary,
        {
            color: '#fff',
            backgroundColor: 'var(--color-app-main)'
        }
    ],
    [
        ActionItemPattern.secondary,
        {
            borderColor: 'var(--color-gray-200)',
            color: '#101828',
            backgroundColor: '#fff'
        }
    ]
])

export const buttonActions: Record<ActionHandleEventType, ButtonConfig[]> = {
    [ActionHandleEventType.OPEN_PAGE]: [
        {
            type: 'select',
            placeHolder: '请选择页面',
            label: '选择页面',
            name: 'openPageId',
            index: 0
        }
    ],
    [ActionHandleEventType.OPEN_LINK]: [
        {
            type: 'input',
            placeHolder: 'https://',
            label: '链接',
            name: 'link',
            index: 0
        }
    ],
    [ActionHandleEventType.SCROLL_TO]: [],
    [ActionHandleEventType.CONTROL]: [],
    [ActionHandleEventType.GO_BACK]: [],
    [ActionHandleEventType.NOTIFICATION]: [
        {
            type: 'input',
            placeHolder: '请输入',
            label: '内容',
            name: 'notificationContent',
            index: 0
        },
        {
            type: 'select',
            placeHolder: '',
            label: '提示类型',
            name: 'notificationStatus',
            index: 1
        }
    ],
    [ActionHandleEventType.COPY]: [
        {
            type: 'input',
            placeHolder: '请输入',
            label: '自定义',
            name: 'copyText',
            index: 1
        }
    ],
    [ActionHandleEventType.CALL]: [],
    [ActionHandleEventType.CREATE_RECORD]: [
        {
            type: 'select',
            placeHolder: '请选择数据表',
            label: '数据表',
            name: 'dataSourceId',
            index: 0
        }
    ],
    [ActionHandleEventType.UPDATE_RECORD]: [],
    [ActionHandleEventType.DELETE_RECORD]: [],
    [ActionHandleEventType.DOWNLOAD_FILE]: [],
    [ActionHandleEventType.ALIYUN_MESSAGE]: [],
    [ActionHandleEventType.WECHAT_PAY]: [],
    [ActionHandleEventType.WECHAT_TEMPLATE_MSG]: [],
    [ActionHandleEventType.STRIPE]: [],
    [ActionHandleEventType.UPDATE_PAGE_STATE]: [],
    [ActionHandleEventType.UPDATE_QUERY_PARAMETER]: [],
    [ActionHandleEventType.UPDATE_PAGE_SHARE]: [],
    [ActionHandleEventType.REFRESH_PAGE]: [],
    [ActionHandleEventType.CLOSE_FLOAT]: [],
    [ActionHandleEventType.SCREEN_SHOT]: [],
    [ActionHandleEventType.WECHAT_SUBSCRIPTION_MSG]: [],
    [ActionHandleEventType.WECHAT_SUBSCRIPTION_MSG_NOTIFICATION]: [],
    [ActionHandleEventType.OPEN_WECHAT_CUSTOMER_SERVICE]: [],
    [ActionHandleEventType.WECHAT_NAVIGATE_TO_MINI_PROGRAM]: [],
    [ActionHandleEventType.WECHAT_OPEN_CHANNELS_ACTIVITY]: [],
    [ActionHandleEventType.ACTION]: [],
    [ActionHandleEventType.AUTOMATION]: []
}

export const btnTypeList: { value: ButtonShowType; label: string }[] = [
    {
        value: 'name',
        label: '仅文字'
    },
    {
        value: 'icon',
        label: '仅图标'
    },
    {
        value: 'icon-name',
        label: '图标加文字'
    }
]

export const btnStyleList: { value: string; label: string }[] = [
    {
        value: '0',
        label: '主按钮'
    },
    {
        value: '1',
        label: '次级按钮'
    }
]

/** 按钮样式 */
export const BUTTON_PATTERN_CONTROL: SegmentedControlItem[] = [
    {
        label: '主按钮',
        value: ActionItemPattern.primary
    },
    {
        label: '次按钮',
        value: ActionItemPattern.secondary
    },
    {
        label: '自定义',
        value: ActionItemPattern.custom
    }
]

export const flowActionTypes = ['flow', 'automation'] as const

export type FlowActionTypes = typeof flowActionTypes[number]

export const buttonSizeMap = new Map<ButtonSizeType, number>([
    [ButtonSize.sm, 32],
    [ButtonSize.md, 36],
    [ButtonSize.lg, 40]
])
